import { useState, useEffect } from 'react';

const navItems = [
  { id: 'index', label: '追剧索引' },
  { id: 'carousel', label: '精选专题' },
  { id: 'topics', label: '热门话题' },
  { id: 'features', label: '平台特色' },
  { id: 'updates', label: '最新动态' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              const el = document.getElementById('hero');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex items-center gap-2.5 cursor-pointer whitespace-nowrap"
          >
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-movie-2-fill text-background-50 text-lg md:text-xl"></i>
            </span>
            <span className="font-heading text-lg md:text-xl text-foreground-950">
              夜猫影院
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('hero');
              }}
              className="px-3.5 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-lg hover:bg-primary-50/60 cursor-pointer whitespace-nowrap"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.id);
                }}
                className="px-3.5 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-lg hover:bg-primary-50/60 cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#app"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('app');
              }}
              className="px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              下载APP
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          <nav className="flex flex-col gap-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('hero');
              }}
              className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50/60 rounded-lg transition-colors cursor-pointer"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.id);
                }}
                className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50/60 rounded-lg transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#app"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('app');
              }}
              className="mt-2 px-3 py-2.5 text-sm font-medium bg-primary-500 text-background-50 rounded-lg text-center hover:bg-primary-600 transition-colors cursor-pointer"
            >
              下载APP
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}